import { useEffect, useState } from "react";
import { getCollectionBanner } from "../../services/productService";
import "./CollectionBanner.css";

function CollectionBanner() {

const [banners, setBanners] = useState([]);
const [currentIndex, setCurrentIndex] = useState(0);

/* =====================================================
LOAD BANNERS
===================================================== */

useEffect(() => {


const loadBanners = async () => {

    try {

        const response = await getCollectionBanner();

        console.log(
            "Collection banner response:",
            response.data
        );

        const bannerData = Array.isArray(response.data)
            ? response.data
            : response.data
                ? [response.data]
                : [];

        console.log(
            "Banner count:",
            bannerData.length
        );

        console.log(
            "Banner URLs:",
            bannerData.map(
                banner => banner.collectionDetailImageUrl
            )
        );

        setBanners(bannerData);
        setCurrentIndex(0);

    } catch (error) {

        console.error(
            "Error loading collection banners:",
            error
        );

    }

};

loadBanners();


}, []);

/* =====================================================
AUTO CAROUSEL
Changes every 15 seconds
===================================================== */

useEffect(() => {


if (banners.length <= 1) {
    return;
}

console.log(
    "Starting carousel. Banners:",
    banners.length
);

const interval = setInterval(() => {

    setCurrentIndex(previousIndex => {

        const nextIndex =
            (previousIndex + 1) % banners.length;

        console.log(
            "Changing banner:",
            previousIndex,
            "→",
            nextIndex
        );

        return nextIndex;

    });

}, 15000);

return () => {
    clearInterval(interval);
};


}, [banners.length]);

/* =====================================================
NO BANNER
===================================================== */

if (banners.length === 0) {
return null;
}

const currentBanner = banners[currentIndex];

/* =====================================================
MANUAL DOT CLICK
===================================================== */

const handleDotClick = (index, event) => {


event.stopPropagation();

setCurrentIndex(index);


};

/* =====================================================
RENDER
===================================================== */

return (


<section className="collection-banner-section">

    <div className="collection-banner-wrapper">

        <div className="collection-banner-container">

            <img
                src={`/${currentBanner.collectionDetailImageUrl}`}
                alt={
                    currentBanner.collectionDetailTitle ||
                    "FarmFox Collection"
                }
                className="collection-banner-image"
            />


            {/* =================================================
                CAROUSEL DOTS
            ================================================= */}

            {banners.length > 1 && (

                <div className="carousel-dots">

                    {banners.map((banner, index) => (

                        <button
                            key={
                                banner.collectionDetailImageUrl ||
                                index
                            }
                            className={
                                index === currentIndex
                                    ? "carousel-dot active"
                                    : "carousel-dot"
                            }
                            onClick={(event) =>
                                handleDotClick(index, event)
                            }
                            aria-label={`Go to banner ${index + 1}`}
                        />

                    ))}

                </div>

            )}

        </div>

    </div>

</section>


);

}

export default CollectionBanner;
